<template>
  <div>
    <DomainHeader></DomainHeader>
    <DomainDomainSearch @query="queryDomain"></DomainDomainSearch>
    <div class="domain-price container mt40">
      <cTitle border>域名价格总览</cTitle>
      <div class="p20">
        <table>
          <tr>
            <th rowspan="2"
                class="pl20 tl">域名类型</th>
            <th colspan="4">注册价格</th>
            <th rowspan="2"
                width="144">续费价格（年）</th>
            <th rowspan="2"
                width="166"
                style="line-height:2;">
              转入价格
              <br>（含1年续费价格）
            </th>
          </tr>
          <tr>
            <th width="80">1年</th>
            <th width="80">3年</th>
            <th width="80">5年</th>
            <th width="80">10年</th>
          </tr>
          <tr v-for="(item,i) in priceList"
              :key="i">
            <td>
              <div class="clearfix">
                <span class="fl ml20">
                  <a :href="`/domain/info-intro/${item[8]}/${getLink(item)}`"
                     target="_blank">{{item[0]}}</a>
                  <span v-if="'.网址'===item[0]"
                        class="label ml10">普通网址</span>
                  <span v-if="cList1.indexOf(item[0])!==-1"
                        class="tag">促</span>
                </span>
                <span class="fr gc f12 mr10">{{item[1]}}</span>
              </div>
            </td>
            <td>￥{{item[2]}}</td>
            <td>￥{{item[3]}}</td>
            <td>￥{{item[4]}}</td>
            <td>￥{{item[5]}}</td>
            <td>￥{{item[6]}}</td>
            <td>￥{{item[7]}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>

</template>

<script>
import priceList from '../static/assets/priceList'
import cTitle from './components/title'
import DomainHeader from './components/header'
import DomainDomainSearch from './components/new-domain-search'
export default {
  data () {
    return {
      priceList,

      cList1: [
        // '英文.com',
        // '英文.cn',
        // '英文.net',
        // '中文.biz',
        // '英文.biz',
        // '.网址',
        // '.在线'
      ],
    }
  },

  components: {
    DomainHeader,
    DomainDomainSearch,
    cTitle,
  },
  methods: {

    getLink (item) {
      const domain = item[0]
      return domain.substr(domain.indexOf('.') + 1).replace('.', '-')
    },
  }
}
</script>

<style lang="scss">
.domain-price {
  background-color: #fff;
  table {
    width: 100%;
    th {
      background-color: rgb(246, 248, 250);
      line-height: 40px;
      font-weight: 400;
      text-align: center;
      border-width: 1px;
      border-style: solid;
      border-color: rgb(229, 229, 229);
      border-image: initial;
      &.tl {
        text-align: left;
      }
    }
    tr {
      &:nth-of-type(2n) {
        background: rgb(246, 248, 250);
      }
      &:hover {
        background: rgb(225, 238, 253);
        td a {
          color: rgb(0, 120, 255);
          text-decoration: underline;
        }
      }
    }
    td {
      line-height: 70px;
      text-align: center;
      border-width: 1px;
      border-style: solid;
      border-color: rgb(229, 229, 229);
      border-image: initial;
      a {
        color: rgb(51, 51, 51);
      }
      .label {
        height: 27px;
        width: 72px;
        color: rgb(255, 180, 0);
        font-size: 12px;
        line-height: 27px;
        text-align: center;
        display: inline-block;
        box-sizing: border-box;
        padding: 0px;
        outline: none;
        border-width: 1px;
        border-style: solid;
        border-color: rgb(255, 180, 0);
        border-image: initial;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/price-table.vue